/**
 * Whole-name / token allowlist for false positives (legitimate names, places, etc.).
 * Compared against normalizeForModeration() output (lowercase, alphanumeric).
 */
export const NAME_MODERATION_ALLOWLIST = new Set([
  'name',
  'dick',
  'gay',
  'ho',
  'william',
  'hancock',
  'grass',
  'class',
  'classic',
  'pass',
  'bass',
  'scunthorpe',
  'cockburn',
  'penistone',
  'fanny',
  'randy',
  'homo',
  'niger', // country
  'negus',
  'cox',
  'wang',
  'shi',
  'tit',
  'titus',
  'arsenal',
]);

export function isAllowlistedNormalizedName(normalized: string): boolean {
  if (!normalized) return false;
  if (NAME_MODERATION_ALLOWLIST.has(normalized)) return true;
  // Allow multi-token names where every token is allowlisted
  const tokens = normalized.split(/\s+/).filter(Boolean);
  if (tokens.length > 1 && tokens.every((t) => NAME_MODERATION_ALLOWLIST.has(t))) {
    return true;
  }
  return false;
}
